const delayPromise = <T>(promise: Promise<T>, minTime: number): Promise<T> => {
  const delay = new Promise<void>((resolve) => setTimeout(resolve, minTime))
  return Promise.all([promise, delay]).then(([result]) => result)
}

export default delayPromise
